import { TweenMax, TimelineMax } from 'gsap';
import dynamic from 'next/dynamic';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import css from './index.module.scss';
import PageLayout from '@/components/PageLayout';
import { useGlobal } from '@/utils/useGlobal';
import { redirectTo404 } from '@/utils';
import ScrollMagicFn from '@/utils/ScrollMagic';
import Group1PC from '@/components/delta2PortablePowerStationEvent/Group1';
import Group1H5 from '@/componentsH5/delta2PortablePowerStationEvent/Group1';
import Group2H5 from '@/componentsH5/delta2PortablePowerStationEvent/Group2';
import Group3H5 from '@/componentsH5/delta2PortablePowerStationEvent/Group3';
import Group4H5 from '@/componentsH5/delta2PortablePowerStationEvent/Group4';
import Annotation from '@/components/Annotation';

const PageConPc = dynamic(() => import('./indexDynamic'), {
    ssr: true,
});

export default function Delta2ActivityPage({ SEO }: any) {
    const { isMobile } = useGlobal();
    if (typeof window !== 'undefined') {
        window.ScrollMagic = ScrollMagicFn();
        ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
    }
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });

    return (
        <PageLayout theme="black">
            <SEO title="DELTA 2 Event" />
            <GtmPageLoad />
            <div className={css.delta2_activity_page}>
                {isMobile && (
                    <>
                        <div className="section group1">
                            <Group1H5 />
                        </div>

                        <div className="section group2">
                            <Group2H5 />
                        </div>

                        <div className="section group3">
                            <Group3H5 />
                        </div>

                        <div className="section group4">
                            <Group4H5 />
                        </div>
                        <Annotation borderTopColor="transparent" bgColor="transparent" />
                    </>
                )}
                {!isMobile && (
                    <>
                        <div className="section group1">
                            <Group1PC />
                        </div>
                        <PageConPc />
                        <Annotation borderTopColor="transparent" bgColor="transparent" boxStyle={{ width: '1120px' }} />
                    </>
                )}
            </div>
        </PageLayout>
    );
}

// 以下两个方法不可删除，否则会重复触发 _app.js 中 getInitialProps 中的请求
export async function getServerSideProps({ locale }: any) {
    const whiteLocaleList = ['us', 'ca', 'uk', 'de', 'fr', 'it', 'es'];
    if (!whiteLocaleList.includes(locale)) {
        return redirectTo404();
    }
    return {
        props: {},
    };
}
